// extracted by mini-css-extract-plugin
export default {"goTo":"styles_goTo__1JfuB"};